import React, { useEffect, useRef } from 'react';
interface ContainerScrollProps {
  maxHeight: string;
  minHeight: string;
  total: number;
  children: React.ReactNode;
}

const ContainerScroll: React.FC<ContainerScrollProps> = ({
  children,
  maxHeight,
  minHeight,
  total,
}) => {
  const scroll: React.MutableRefObject<any> = useRef(null);
  useEffect(() => {
    const itens = new Promise((resolve) => {
      if (total > 0) scroll?.current?.scrollHeight && resolve(true);
    });

    itens.then((data: any) => {
      if (data) {
        if (scroll.current) {
          const timeoutID = setTimeout(() => {
            scroll.current.scrollTop = scroll?.current?.scrollHeight;
          }, 0);

          return () => clearTimeout(timeoutID);
        }
      }
    });
  }, [total, scroll]);
  return (
    <div
      id="scroll"
      ref={scroll}
      style={{
        padding: '10px',
        maxHeight: maxHeight,
        minHeight: minHeight,
        overflowY: 'scroll',
        overflowX: 'hidden',
        scrollBehavior: 'smooth',
      }}
    >
      {children}
    </div>
  );
};

export default ContainerScroll;
